Object.defineProperty(exports, "__esModule", { value: true })

exports.default = __webpack_require__.stylable.create(
  "root",
  "AuthorInfo822883024",
  {"root":"AuthorInfo822883024--root","avatar":"AuthorInfo822883024--avatar","timestamp":"AuthorInfo822883024--timestamp","relationship":"AuthorInfo822883024--relationship"},
  "",
  8,
  "AuthorInfo822883024"
);

